// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"b2c63650d6a044ebd404","351":"4f698cfb6f5f4c8d66e9"}[chunkId] + ".js";
};